import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import { Alert, Badge, Modal, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { baseUrl } from "../../../services/config";
import { useAlert } from "react-alert";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import Select from "react-select";

const UserBanks = () => {
  const alert = useAlert();
  const [deleteModal, setdeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  let [errorcreate, seterrorcreate] = useState("Please fill all fields");
  let [isallfields, setisallfields] = useState(false);

  const [deleteId, setDeleteId] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [addloading, setaddloading] = useState(false);
  const [usersData, setUsersData] = useState([]);
  let authToken = localStorage.getItem("userToken");
  const [userBanks, setUserBanks] = useState([]);

  const user = useSelector((state) => state.user.user);
  console.log(user, "user");
  const [addUserId, setAddUserId] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [accountsList, setAccountsList] = useState([]);
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [editUserId, setEditUserId] = useState("");
  const [editSelectedBanks, setEditSelectedBanks] = useState([]);
  useEffect(() => {
    GetAllUsers();
    getBankAccountList();
    getAllUserBanks();
  }, []);

  const GetAllUsers = async () => {
    await fetch(`${baseUrl}/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUsersData(data.payload);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getBankAccountList = async () => {
    await fetch(`${baseUrl}/bank-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [
          {
            label: "Select All Bank Accounts",
            value: "select_all",
          },
        ];
        data.payload.forEach((element) => {
          arr.push({
            label: element.bank_name,
            value: element.id,
            // account_chart_id: element.account_chart_id,
          });
        });
        setAccountsList(arr);
        console.log(data, "Test Hassan");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUserChange = (value) => {
    setSelectedUser(value);
    getUserBanks(value);
  };

  const getUserBanks = (selectedUser) => {
    if (selectedUser == "") {
      return getAllUserBanks();
    }
    setLoading(true);

    fetch(`${baseUrl}/user-bank-accounts/user/${selectedUser}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setUserBanks(data.payload);
          setLoading(false);
        } else {
          alert.error("No Record Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllUserBanks = () => {
    setLoading(true);

    fetch(`${baseUrl}/user-bank-accounts`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setUserBanks(data.payload);
          setLoading(false);
        } else {
          alert.error("No Record Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addeUserBanksHandle = () => {
    if (selectedBanks.length === 0 || addUserId === "") {
      setisallfields(true);
      setLoading(false);
      return;
    }
    const data = {
      user_id: addUserId,
      bank_account_ids: selectedBanks.map((item) => item.value),
    };

    setaddloading(true);
    fetch(`${baseUrl}/user-bank-accounts`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("User Banks Add Successfully");
            setaddloading(false);
            setAddModal(false);
            setSelectedBanks([]);
            getUserBanks(selectedUser);
          } else {
            alert.error("User Banks Not Updated");
            setaddloading(false);
            setAddModal(false);
          }
        })
      )
      .catch((err) => {
        console.log(err);
        setaddloading(false);
        setAddModal(false);
      });
  };

  const handleBanksChange = (selectedOptions) => {
    if (selectedOptions == null) {
      setSelectedBanks([]);
      return;
    }
    if (selectedOptions.some((option) => option.value === "select_all")) {
      setSelectedBanks(
        accountsList.filter((option) => option.value !== "select_all")
      );
    } else {
      setSelectedBanks(selectedOptions);
    }
  };

  const handleEditBanksChange = (selectedOptions) => {
    if (selectedOptions == null) {
      setEditSelectedBanks([]);
      return;
    }
    if (selectedOptions.some((option) => option.value === "select_all")) {
      setEditSelectedBanks(
        accountsList.filter((option) => option.value !== "select_all")
      );
    } else {
      setEditSelectedBanks(selectedOptions);
    }
  };

  const middleFunc = (row) => {
    setEditUserId(row?.id);
    let arr =
      row?.bank_accounts?.map((element) => ({
        label: element.bank_name,
        value: element.id,
      })) || [];
    setEditSelectedBanks(arr);
    console.log(
      row?.id,
      row?.bank_accounts?.map((item) => item.id),
      arr
    );
    setEditModal(true);
  };

  const updateUserCampusHandle = () => {
    if (editUserId == "" || editSelectedBanks == "") {
      setisallfields(true);
      return;
    }
    const data = {
      user_id: editUserId,
      bank_account_ids: editSelectedBanks.map((item) => item.value),
    };

    setaddloading(true);
    fetch(`${baseUrl}/user-bank-accounts`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("User Banks Updated Successfully");
            setLoading(false);
            setaddloading(false);
            setEditModal(false);
            getUserBanks(selectedUser);
          } else {
            alert.error("User Banks Not Updated");
            setaddloading(false);
            setEditModal(false);
          }
        })
      )
      .catch((err) => {
        console.log(err);
        setaddloading(false);
        setEditModal(false);
      });
  };

  const openDelete = (row) => {
    setDeleteId(row.id);
    setdeleteModal(true);
  };

  const DeleteUserBanksHandler = () => {
    setLoading(true);
    fetch(`${baseUrl}/user-bank-accounts/${deleteId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success == true) {
            alert.success("User Banks Deleted Successfull");
            setLoading(false);
            setdeleteModal(false);
            getUserBanks(selectedUser);
          } else {
            alert.error("something went wrong!");
            setLoading(false);
            setdeleteModal(false);
          }
        })
      )
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setdeleteModal(false);
      });
  };

  return (
    <Paper className="mt-4 mb-4 p-5">
      <div>
        <button
          className="btn btn-primary"
          onClick={() => setAddModal(true)}
          style={{ margin: 5 }}
        >
          Add User Banks
        </button>
      </div>

      <div className="row mt-5 mb-5">
        <div className="col-md-4">
          <label className="form-label">
            <b>Select User</b> <span style={{ color: "red" }}> *</span>
          </label>
          <select
            className="form-select"
            name="user_id"
            style={{ height: 37 }}
            aria-label="Default select example"
            value={selectedUser}
            onChange={(e) => handleUserChange(e.target.value)}
          >
            <option value="">Select User</option>
            {usersData &&
              usersData.map((item, index) => (
                <>
                  <option key={index} value={item?.id}>
                    {item?.first_name + " " + item?.last_name}
                  </option>
                </>
              ))}
          </select>
        </div>
      </div>

      <Table>
        <thead>
          <tr className="text-center">
            <th>Sr.No</th>
            <th style={{ textAlign: "start" }}>User Name</th>
            <th>Bank Accounts</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {userBanks &&
            (Array.isArray(userBanks) ? userBanks : [userBanks])
              .filter((item) => item && typeof item === "object")
              .map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td
                    style={{ textAlign: "start" }}
                  >{`${row?.first_name} ${row?.last_name}`}</td>
                  <td style={{ textAlign: "start" }}>
                    {row.bank_accounts.map((item) => {
                      return (
                        <Badge
                          style={{
                            backgroundColor: "black",
                            marginRight: "2px",
                          }}
                          bg="primary"
                        >
                          {item?.bank_name}
                        </Badge>
                      );
                    })}
                  </td>

                  <td>
                    <span
                      onClick={() => middleFunc(row)}
                      style={{ cursor: "pointer" }}
                      className="svg-icon svg-icon-md svg-icon-primary-custom"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg"
                        )}
                      />
                    </span>
                  </td>
                  <td>
                    <span
                      onClick={() => openDelete(row)}
                      style={{ cursor: "pointer" }}
                      className="svg-icon svg-icon-md svg-icon-danger"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Trash.svg"
                        )}
                      />
                    </span>
                  </td>
                </tr>
              ))}
        </tbody>
      </Table>

      <div className="row justify-content-center">
        {loading ? <span className="spinner-border"></span> : null}
      </div>

      {/* Add User Banks  */}
      <Modal
        size="lg"
        show={addModal}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Add User Banks
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {addloading ? (
            <b style={{ color: "green" }}>
              User Banks Adding Please Wait {` `}{" "}
              <span className="spinner-border"></span>
            </b>
          ) : (
            <div>
              <div className="form-group row">
                <div className="col-lg-6">
                  <label className="form-label">
                    <b>Select User</b> <span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-select"
                    name="user_id"
                    style={{ height: 37 }}
                    aria-label="Default select example"
                    value={addUserId}
                    onChange={(e) => setAddUserId(e.target.value)}
                  >
                    <option value="">Select User</option>
                    {usersData &&
                      usersData.map((item, index) => (
                        <>
                          <option key={index} value={item?.id}>
                            {item?.first_name + " " + item?.last_name}
                          </option>
                        </>
                      ))}
                  </select>
                </div>

                <div className="col-lg-6">
                  <label>
                    <b>Select Banks</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <Select
                    isMulti
                    value={selectedBanks}
                    onChange={(newVal) => handleBanksChange(newVal)}
                    options={accountsList}
                  />
                </div>
              </div>

              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>{errorcreate}</p>
                  </Alert>
                </>
              ) : null}

              <br />
              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-primary mx-4"
                  onClick={() => addeUserBanksHandle()}
                  disabled={loading}
                >
                  Add User Banks
                </button>

                <Link to="/user-banks">
                  <button
                    onClick={() => {
                      setisallfields(false);
                      setAddModal(false);
                    }}
                    type="button"
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Edit  User Banks*/}
      <Modal
        size="lg"
        show={editModal}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Update User Banks
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {addloading ? (
            <b style={{ color: "green" }}>
              User Campus Updating Please Wait {` `}{" "}
              <span className="spinner-border"></span>
            </b>
          ) : (
            <div>
              <div className="form-group row">
                <div className="col-lg-6">
                  <label className="form-label">
                    <b>Select User</b> <span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-select"
                    name="user_id"
                    style={{ height: 37 }}
                    aria-label="Default select example"
                    value={editUserId}
                    onChange={(e) => setEditUserId(e.target.value)}
                  >
                    <option value="">Select User</option>
                    {usersData &&
                      usersData.map((item, index) => (
                        <>
                          <option key={index} value={item?.id}>
                            {item?.first_name + " " + item?.last_name}
                          </option>
                        </>
                      ))}
                  </select>
                </div>

                <div className="col-lg-6">
                  <label>
                    <b>Select Banks</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <Select
                    isMulti
                    value={editSelectedBanks}
                    onChange={(newVal) => handleEditBanksChange(newVal)}
                    options={accountsList}
                  />
                </div>
              </div>

              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>{errorcreate}</p>
                  </Alert>
                </>
              ) : null}

              <br />
              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-primary mx-4"
                  onClick={() => updateUserCampusHandle()}
                  disabled={loading}
                >
                  Update
                </button>

                <Link to="/user-banks">
                  <button
                    onClick={() => {
                      setisallfields(false);
                      setEditUserId("");
                      setEditSelectedBanks([]);
                      setEditModal(false);
                    }}
                    type="button"
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Delete User Banks */}
      <Modal show={deleteModal}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Are you sure want to delete this user banks?
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button onClick={DeleteUserBanksHandler} className="btn button_blue">
            Delete
          </button>
          <button
            onClick={() => setdeleteModal(false)}
            className="btn btn-danger btn_width"
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </Paper>
  );
};

export default UserBanks;
